(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7212],{

/***/ 85870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/setup",
      function () {
        return __webpack_require__(35956);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_googleCloudStep_Dashboard1__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96435);
/* harmony import */ var src_components_googleCloudStep_Finish__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20605);
/* harmony import */ var src_components_googleCloudStep_Start__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92765);
/* harmony import */ var src_components_googleCloudStep_GoogleDrive__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67630);
/* harmony import */ var src_components_googleCloudStep_PhotosVideos__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28563);
/* harmony import */ var src_components_googleCloudStep_Locations__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71682);
/* harmony import */ var src_components_googleCloudStep_Chrome__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51320);
/* harmony import */ var src_components_googleCloudStep_Contacts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27087);
/* harmony import */ var src_components_googleCloudStep_TroubleShooting__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52061);
/* harmony import */ var src_components_googleCloudStep_WhatsApp__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84518);
/* harmony import */ var src_components_googleCloudStep_BackupTips__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98372);
/* harmony import */ var src_components_googleCloudStep_CloudHavePhone__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(678);
/* harmony import */ var src_components_googleCloudStep_CloudNoPhone__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59108);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19630);
/* harmony import */ var src_api_login_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53399);
/* harmony import */ var src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(32870);
/* harmony import */ var src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(99518);


// ** Icon Imports




















function Index() {
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const [currentItem, setCurrentItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("BackupTips");
    const [appKey, setAppKey] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    const [setupBlocked, setSetupBlocked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    //移动端全屏
    const [fullScreen, setFullScreen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const StepProgress = (param)=>{
        let { current , total =5  } = param;
        const barWidth = 72;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const guard = (0,src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_19__/* .guardAppSetupOrderId */ .Bq)(window.location.search);
        if (guard.blocked) {
            setSetupBlocked(true);
            return;
        }
        setSetupBlocked(false);
        if (guard.orderId) return;
        const init = async ()=>{
            const result = await (0,src_api_login_js__WEBPACK_IMPORTED_MODULE_18__.getNotBindOrder)();
            await (0,src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_20__/* .redirectIfShouldBuyPackage */ .og)(result);
        };
        init();
    }, []);
    if (setupBlocked) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "Blds:shadow-step rounded-[10px] overflow-hidden bg-white relative h-[88vh] Local-step ".concat((currentItem === "CloudHavePhone" || currentItem === "CloudNoPhone") && "!h-[calc(100vh-62px)]"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-white h-full flex flex-col",
                id: "android-dashboard-login",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "Dmd:pb-[0px] Dsm:w-[calc(100%-40px)] mx-auto overflow-auto w-full mt-[60px] smj:mt-4 ".concat(currentItem === "CloudHavePhone" || currentItem === "CloudNoPhone" ? "Dsm:pb-0" : "Dsm:pb-[45px]"),
                        children: [
                            currentItem === "CloudHavePhone" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_CloudHavePhone__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                setCurrentItem: setCurrentItem
                            }),
                            currentItem === "CloudNoPhone" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_CloudNoPhone__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                setCurrentItem: setCurrentItem
                            }),
                            currentItem === "Finish" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepProgress, {
                                current: 4
                            }) : currentItem !== "Start" && currentItem !== "Finish" && currentItem !== "App" && currentItem !== "BackupTips" && currentItem !== "Dashboard" && currentItem !== "CloudHavePhone" && currentItem !== "CloudNoPhone" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepProgress, {
                                current: 5
                            }),
                            currentItem === "BackupTips" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_BackupTips__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    setCurrentItem: setCurrentItem,
                                    fullScreen: fullScreen,
                                    setFullScreen: setFullScreen
                                })
                            }),
                            currentItem !== "Start" && currentItem !== "Finish" && currentItem !== "App" && currentItem !== "BackupTips" && currentItem !== "Dashboard" && currentItem !== "CloudHavePhone" && currentItem !== "CloudNoPhone" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full h-[60px] Dsm:h-[58px] flex items-start",
                                children: [
                                    (currentItem === "Google drive" || currentItem === "Locations" || currentItem === "WhatsApp" || currentItem === "Photos & videos" || currentItem === "Chrome" || currentItem === "Contacts" || currentItem === "Trouble shooting") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "overflow-auto h-[42px] Dsm:h-[32px] bg-[#EEEEEF] rounded-[8px] p-[2px] flex justify-between mx-auto text-nowrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "Google drive" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("Google drive"),
                                                children: t("Google drive")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "Locations" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("Locations"),
                                                children: t("Locations")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "WhatsApp" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("WhatsApp"),
                                                children: t("WhatsApp")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "Photos & videos" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("Photos & videos"),
                                                children: t("Photos  videos")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "Chrome" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("Chrome"),
                                                children: t("Chrome")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "Contacts" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("Contacts"),
                                                children: t("Contacts")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "".concat(currentItem === "Trouble shooting" ? "text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]" : "text-[#000]", " px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer"),
                                                onClick: ()=>setCurrentItem("Trouble shooting"),
                                                children: t("Trouble shooting")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]",
                                                        onClick: ()=>{
                                                            setCurrentItem("Finish");
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                className: "mr-[7px]",
                                                                src: "/images/bind/bind-arrow-blue.svg",
                                                                width: 18,
                                                                height: 18,
                                                                alt: "back"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[15px] text-[#454CFF] font-[600]",
                                                                children: t("BACK")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px]",
                                                        onClick: ()=>{
                                                            window.location.assign("/");
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-[15px] text-[#1B1C2B] font-[600]",
                                                                children: t("NEXT")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                className: "ml-[6px]",
                                                                src: "/images/bind/bind-arrow-black.svg",
                                                                width: 18,
                                                                height: 18,
                                                                alt: "back"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            currentItem === "Start" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_Start__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                setCurrentItem: setCurrentItem
                            }),
                            (currentItem === "Dashboard" || currentItem === "App" || currentItem === "Plugin") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_Dashboard1__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                currentItem: currentItem,
                                setCurrentItem: setCurrentItem,
                                appKey: appKey,
                                fullScreen: fullScreen,
                                setFullScreen: setFullScreen
                            }),
                            currentItem === "Finish" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_Finish__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                setCurrentItem: setCurrentItem
                            }),
                            currentItem === "Google drive" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_GoogleDrive__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                            currentItem === "Locations" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_Locations__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                            currentItem === "WhatsApp" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_WhatsApp__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}),
                            currentItem === "Photos & videos" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_PhotosVideos__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                            currentItem === "Chrome" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_Chrome__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                            currentItem === "Contacts" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_Contacts__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {}),
                            currentItem === "Trouble shooting" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_googleCloudStep_TroubleShooting__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
                        ]
                    }),
                    (currentItem === "App" || currentItem === "Plugin") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[120px] Dsm:hidden"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,210,1664,2586,6456,1978,9808,2870,2912,7727,9774,2888,179], function() { return __webpack_exec__(85870); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);